import { IntlSubtitleDTO } from '@/services/content-api-types';

import Document from './Document';

import { DocumentDto } from '@/_generated/api-clients/xp';

interface SubtitleDocumentsProps {
  disableSixDotMenuHandles?: boolean;
  handleToggleDocument: (
    document: DocumentDto,
    documentIsCurrentlyVisible: boolean,
  ) => void;
  handleDocumentDelete: (
    document: DocumentDto,
    documentIsCurrentlyVisible: boolean,
    documentIndex: number,
  ) => void;
  openDocumentInNewTab: boolean;
  subtitle: IntlSubtitleDTO;
}

const SubtitleDocuments: React.FC<SubtitleDocumentsProps> = ({
  disableSixDotMenuHandles,
  openDocumentInNewTab,
  handleToggleDocument,
  handleDocumentDelete,
  subtitle,
}) => {
  const documentVisibilityCheck = (document: DocumentDto) => {
    if (!document.id) return;
    const { visibleDocuments: visibleDocumentIds, documents: allDocuments } =
      subtitle;
    const visibleDocumentIndex = visibleDocumentIds?.indexOf(document.id);
    const hiddenDocumentIndex = allDocuments.findIndex(
      d => d.id === document.id,
    );

    if (
      typeof visibleDocumentIndex !== 'undefined' &&
      visibleDocumentIndex >= 0
    ) {
      return true;
    }
    if (
      visibleDocumentIndex &&
      hiddenDocumentIndex &&
      visibleDocumentIndex < 0 &&
      hiddenDocumentIndex >= 0
    ) {
      return false;
    }
  };

  return (
    <>
      {subtitle.documents.map((doc, idx) => {
        const documentIsCurrentlyVisible =
          documentVisibilityCheck(doc) ?? false;
        return (
          <Document
            disableSixDotMenuHandles={disableSixDotMenuHandles}
            document={doc}
            documentIsCurrentlyVisible={documentIsCurrentlyVisible}
            handleDocumentDeleteButton={() => {
              handleDocumentDelete(doc, documentIsCurrentlyVisible, idx);
            }}
            handleDocumentVisibilityToggle={() => {
              handleToggleDocument(doc, documentIsCurrentlyVisible);
            }}
            inSectionPreview={true}
            key={idx}
            openInNewTab={openDocumentInNewTab}
          />
        );
      })}
    </>
  );
};

export default SubtitleDocuments;
